import { useEntityMutation } from './useEntityMutation';
import { viatgerMutationConfig } from '@/lib/entity-configs';

/**
 * Hook per actualitzar viatgers
 * @deprecated Usa useEntityMutation amb viatgerMutationConfig directament
 */
export function useUpdateViatger() {
  const { updateMutation } = useEntityMutation(viatgerMutationConfig);
  return updateMutation;
}
